import { useEffect } from 'react';

/**
 * Warns users not to close the tab during signup provisioning (createTenant).
 * Browsers show a generic confirmation dialog; copy is conveyed in on-page messaging.
 */
export function useSignupKeepPageOpen(enabled) {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [enabled]);
}
